module.exports = __webpack_public_path__ + "img/IMG_8906.aa0a34e1.png";